import "./Home.scss";
import { FaDiscord, FaGithub, FaBookOpen, FaHdd } from 'react-icons/fa';

export default function Home({toggleHamburger, EXTERNAL_LINKS}) {

  return (
    <div className="homeContainer">
      <header className={!toggleHamburger ? "homeContainer active" : ""}>
        <div className="details-text">
          <h1>CommandPanels</h1>
          <p>A Custom GUI plugin for Minecraft Servers.</p>
        </div>
        <div className="download">
          <a href={EXTERNAL_LINKS.Download} target="_blank">
            <button id="jarButton">
              Download
              <span>Available Versions</span>
            </button>
          </a>
        </div>
      </header>

        {/* content section */}
        <section className={!toggleHamburger ? "content active" : "content"}>
          <div id="homeText">
            <h1>Powering servers since 2019</h1>
            <p>CommandPanels is a menu plugin built for server owners who want full control over the player experience. Designed with a tight scope to focus only on what matters and do it well, it stays fast, stable, and easy to maintain while still including the advanced features you need.</p>
            <p>Supports three panel types: <strong>Inventory GUIs</strong>, <strong>Dialogs</strong>, and <strong>Bedrock/Floodgate Forms</strong>, giving you native compatibility with both Java and Bedrock players via Geyser and Floodgate.</p>
            <p>The <strong>Web Editor</strong> is a fully interactive visual builder with every plugin feature included. It offers full feature parity, accurate live previews, support for all panel types, and requires no account to use. New features ship in the editor alongside the plugin, not as an afterthought.</p>
            <p>The <strong>Logic Engine</strong> lets you build menus that react to players rather than just displaying static items. The <strong>Permission Observer</strong> dynamically watches the permission nodes used in a panel's logic. When a relevant permission changes, the panel refreshes automatically with no polling or refresh intervals needed.</p>
            <p>From simple kit menus to full MMO experiences with shops, quests, and navigation, CommandPanels provides the tools to build a professional, responsive server interface.</p>
          </div>
          <div id="homeButtons">
          <button className="discordButton homeButton">
              <a href={EXTERNAL_LINKS.Discord} target="_blank">
                <div className="buttonContent">
                  <FaDiscord className="buttonIcon" />
                  <div className="buttonTextContainer">
                    <span className="buttonText">Discord</span>
                    <span className="buttonSubtitle">Join the community Discord Server</span>
                  </div>
                </div>
              </a>
            </button>

            <button className="homeButton">
              <a href={EXTERNAL_LINKS.Docs}>
                <div className="buttonContent">
                  <FaBookOpen className="buttonIcon"/>
                  <div className="buttonTextContainer">
                    <span className="buttonText">Documentation</span>
                    <span className="buttonSubtitle">Learn more about our plugin</span>
                  </div>
                </div>
              </a>
            </button>

            <button className="githubButton homeButton">
              <a href={EXTERNAL_LINKS.GitHub} target="_blank">
                <div className="buttonContent">
                  <FaGithub className="buttonIcon" />
                  <div className="buttonTextContainer">
                    <span className="buttonText">Github</span>
                    <span className="buttonSubtitle">See the plugins source code</span>
                  </div>
                </div>
              </a>
            </button>

            <button className="editorButton homeButton">
              <a href={EXTERNAL_LINKS.bStats} target="_blank">
                  <div className="buttonContent">
                    <FaHdd className="buttonIcon" />
                    <div className="buttonTextContainer">
                      <span className="buttonText">bStats</span>
                      <span className="buttonSubtitle">View plugin stats on bStats</span>
                    </div>
                  </div>
                </a>
            </button>
          </div>
        </section>
      </div>
  );
}